import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { hideLoader, showLoader } from 'actions/loader';
import useOnNavigationBack from './useOnNavigationBack';

const useGlobalLoader = (condition, { hideOnBack = false } = {}) => {
  const dispatch = useDispatch();

  useOnNavigationBack(() => {
    if (hideOnBack) dispatch(hideLoader());
  });

  useEffect(() => {
    condition ? dispatch(showLoader()) : dispatch(hideLoader());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [condition]);
};

export default useGlobalLoader;
